module.exports = __webpack_public_path__ + "img/4c2c76b1ec9ea74434ebf428fdae366.2fcb41ab.png";